// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-media .swiper-container,
app-media swiper-container {
  height: 201px;
  padding-bottom: 19px !important;
  display: block !important;
  border-radius: 12px;
  padding-right: 0 !important;
  margin-top: 57px !important;
  width: 100% !important;
}
app-media .swiper-container .swiper-slide,
app-media .swiper-container swiper-slide,
app-media swiper-container .swiper-slide,
app-media swiper-container swiper-slide {
  height: 100%;
  display: block !important;
  margin-right: 10px !important;
}
app-media .swiper-container .swiper-slide > div,
app-media .swiper-container .swiper-slide [plyr],
app-media .swiper-container .swiper-slide iframe,
app-media .swiper-container .swiper-slide img,
app-media .swiper-container .swiper-slide video-js,
app-media .swiper-container .swiper-slide video,
app-media .swiper-container swiper-slide > div,
app-media .swiper-container swiper-slide [plyr],
app-media .swiper-container swiper-slide iframe,
app-media .swiper-container swiper-slide img,
app-media .swiper-container swiper-slide video-js,
app-media .swiper-container swiper-slide video,
app-media swiper-container .swiper-slide > div,
app-media swiper-container .swiper-slide [plyr],
app-media swiper-container .swiper-slide iframe,
app-media swiper-container .swiper-slide img,
app-media swiper-container .swiper-slide video-js,
app-media swiper-container .swiper-slide video,
app-media swiper-container swiper-slide > div,
app-media swiper-container swiper-slide [plyr],
app-media swiper-container swiper-slide iframe,
app-media swiper-container swiper-slide img,
app-media swiper-container swiper-slide video-js,
app-media swiper-container swiper-slide video {
  height: 100% !important;
  object-fit: cover !important;
  display: block;
  width: 100% !important;
  border: 0;
  border-radius: 12px;
}
app-media .swiper-container .swiper-slide iframe,
app-media .swiper-container swiper-slide iframe,
app-media swiper-container .swiper-slide iframe,
app-media swiper-container swiper-slide iframe {
  object-fit: fill !important;
}
app-media .bc-player-default_default .vjs-big-play-button {
  background: #00b3ff;
  background: rgba(var(--ion-color-primary-rgb), 0.8) !important;
  border: 0;
  border-radius: 100%;
  color: #fff;
  color: var(--plyr-video-control-color, #fff);
  left: 50%;
  opacity: 0.9;
  padding: 15px;
  padding: calc(var(--plyr-control-spacing, 10px) * 1.5);
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: 0.3s;
  z-index: 2;
  width: 48px;
  height: 48px;
  line-height: 48px;
  transition: all 0s !important;
  margin: 0;
}
app-media .video-js .vjs-play-progress {
  background-color: rgb(var(--ion-color-primary-rgb));
}
app-media .video-js .vjs-control-bar {
  background: transparent;
}
app-media .swiper-pagination-fraction,
app-media .swiper-pagination-custom,
app-media .swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  display: none;
}
app-media .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 10px;
}
app-media .plyr__video-wrapper {
  z-index: 0;
}
app-media .plyr__poster {
  background-size: cover !important;
  z-index: 3;
}
app-media .plyr__control--overlaid,
app-media .plyr--video .plyr__controls {
  z-index: 4;
}
app-media .options {
  height: 328px;
  height: 295px;
  padding-bottom: 35px !important;
  background: transparent;
}
app-media .options .swiper-slide,
app-media .options swiper-slide {
  background: #fff;
}
app-media .options .swiper-slide > div:first-child,
app-media .options swiper-slide > div:first-child {
  height: 250px !important;
}
app-media .options .swiper-slide > div:last-child,
app-media .options swiper-slide > div:last-child {
  height: auto !important;
  text-align: center;
}
app-media .options .swiper-slide > div:last-child ion-icon,
app-media .options swiper-slide > div:last-child ion-icon {
  margin: 13px 20px;
  font-size: 19px;
  color: #999;
}
app-media .caption {
  position: absolute;
  z-index: 10;
  pointer-events: none;
  top: 210px;
  left: 20px;
  color: #fff;
  text-shadow: -1px 0px 1px #000000;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  padding-right: 40px;
  text-align: left;
}

.plyr--full-ui input[type=range] {
  color: var(--ion-color-primary);
}

.plyr__control--overlaid {
  background: rgba(var(--ion-color-primary-rgb), 0.8);
}

.plyr--video .plyr__control.plyr__tab-focus,
.plyr--video .plyr__control:hover,
.plyr--video .plyr__control[aria-expanded=true] {
  background: var(--ion-color-primary);
}

.plyr__control.plyr__tab-focus {
  box-shadow: 0 0 0 5px rgba(var(--ion-color-primary-rgb), 0.5);
}

.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]::before {
  background: var(--ion-color-primary);
}

.plyr--paused iframe {
  opacity: 0;
}
.plyr--paused .plyr__poster {
  width: 100% !important;
  height: 100% !important;
  opacity: 1;
}

.plyr--stopped.plyr__poster-enabled iframe {
  opacity: 0;
}
.plyr--stopped.plyr__poster-enabled .plyr__poster {
  width: 100% !important;
  height: 100% !important;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/components/media/media.component.scss"],"names":[],"mappings":"AACE;;EAEE,aAAA;EACA,+BAAA;EACA,yBAAA;EACA,mBAAA;EACA,2BAAA;EACA,2BAAA;EACA,sBAAA;AAAJ;AAEI;;;;EAEE,YAAA;EACA,yBAAA;EACA,6BAAA;AAEN;AADM;;;;;;;;;;;;;;;;;;;;;;;;EAME,uBAAA;EACA,4BAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAqBR;AAnBM;;;;EACE,2BAAA;AAwBR;AApBE;EACE,mBAAA;EACA,8DAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,4CAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sDAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AAsBJ;AApBE;EACE,mDAAA;AAsBJ;AApBE;EACE,uBAAA;AAsBJ;AAhBE;;;EAGE,YAAA;EACA,aAAA;AAkBJ;AAfE;EAGE,cAAA;AAeJ;AAbE;EACE,UAAA;AAeJ;AAbE;EACE,iCAAA;EACA,UAAA;AAeJ;AAbE;;EAEE,UAAA;AAeJ;AAbE;EACE,aAAA;EACA,aAAA;EACA,+BAAA;EACA,uBAAA;AAeJ;AAdI;;EAEE,gBAAA;AAgBN;AAdM;;EACE,wBAAA;AAiBR;AAdM;;EACE,uBAAA;EACA,kBAAA;AAiBR;AAhBQ;;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAmBV;AAdE;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,iCAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAgBJ;;AAbA;EACE,+BAAA;AAgBF;;AAbA;EACE,mDAAA;AAgBF;;AAbA;;;EAGE,oCAAA;AAgBF;;AAbA;EACE,6DAAA;AAgBF;;AAbA;EAEE,oCAAA;AAeF;;AAXE;EACE,UAAA;AAcJ;AAZE;EACE,sBAAA;EACA,uBAAA;EACA,UAAA;AAcJ;;AATE;EACE,UAAA;AAYJ;AAVE;EACE,sBAAA;EACA,uBAAA;EACA,UAAA;AAYJ","sourcesContent":["app-media {\n  .swiper-container,\n  swiper-container {\n    height: 201px;\n    padding-bottom: 19px !important;\n    display: block !important;\n    border-radius: 12px;\n    padding-right: 0 !important;\n    margin-top: 57px !important;\n    width: 100% !important;\n\n    .swiper-slide,\n    swiper-slide {\n      height: 100%;\n      display: block !important;\n      margin-right: 10px !important;\n      > div,\n      [plyr],\n      iframe,\n      img,\n      video-js,\n      video {\n        height: 100% !important;\n        object-fit: cover !important;\n        display: block;\n        width: 100% !important;\n        border: 0;\n        border-radius: 12px;\n      }\n      iframe {\n        object-fit: fill !important;\n      }\n    }\n  }\n  .bc-player-default_default .vjs-big-play-button {\n    background: #00b3ff;\n    background: rgba(var(--ion-color-primary-rgb), 0.8) !important;\n    border: 0;\n    border-radius: 100%;\n    color: #fff;\n    color: var(--plyr-video-control-color, #fff);\n    left: 50%;\n    opacity: 0.9;\n    padding: calc(10px * 1.5);\n    padding: calc(var(--plyr-control-spacing, 10px) * 1.5);\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    transition: 0.3s;\n    z-index: 2;\n    width: 48px;\n    height: 48px;\n    line-height: 48px;\n    transition: all 0s !important;\n    margin: 0;\n  }\n  .video-js .vjs-play-progress {\n    background-color: rgb(var(--ion-color-primary-rgb));\n  }\n  .video-js .vjs-control-bar {\n    background: transparent;\n  }\n  .swiper-container {\n    //padding-bottom: 10px !important;\n  }\n\n  .swiper-pagination-fraction,\n  .swiper-pagination-custom,\n  .swiper-container-horizontal > .swiper-pagination-bullets {\n    bottom: 10px;\n    display: none;\n  }\n\n  .swiper-container-horizontal\n    > .swiper-pagination-bullets\n    .swiper-pagination-bullet {\n    margin: 0 10px;\n  }\n  .plyr__video-wrapper {\n    z-index: 0;\n  }\n  .plyr__poster {\n    background-size: cover !important;\n    z-index: 3;\n  }\n  .plyr__control--overlaid,\n  .plyr--video .plyr__controls {\n    z-index: 4;\n  }\n  .options {\n    height: 328px;\n    height: 295px;\n    padding-bottom: 35px !important;\n    background: transparent;\n    .swiper-slide,\n    swiper-slide {\n      background: #fff;\n\n      > div:first-child {\n        height: 250px !important;\n      }\n\n      > div:last-child {\n        height: auto !important;\n        text-align: center;\n        ion-icon {\n          margin: 13px 20px;\n          font-size: 19px;\n          color: #999;\n        }\n      }\n    }\n  }\n  .caption {\n    position: absolute;\n    z-index: 10;\n    pointer-events: none;\n    top: 210px;\n    left: 20px;\n    color: #fff;\n    text-shadow: -1px 0px 1px #000000;\n    font-size: 14px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 100%;\n    padding-right: 40px;\n    text-align: left;\n  }\n}\n.plyr--full-ui input[type=\"range\"] {\n  color: var(--ion-color-primary);\n}\n\n.plyr__control--overlaid {\n  background: rgba(var(--ion-color-primary-rgb), 0.8);\n}\n\n.plyr--video .plyr__control.plyr__tab-focus,\n.plyr--video .plyr__control:hover,\n.plyr--video .plyr__control[aria-expanded=\"true\"] {\n  background: var(--ion-color-primary);\n}\n\n.plyr__control.plyr__tab-focus {\n  box-shadow: 0 0 0 5px rgba(var(--ion-color-primary-rgb), 0.5);\n}\n\n.plyr__menu__container\n  .plyr__control[role=\"menuitemradio\"][aria-checked=\"true\"]::before {\n  background: var(--ion-color-primary);\n}\n// player paused state after video has been played, does not cover any focusable elements for mouse users\n.plyr--paused {\n  iframe {\n    opacity: 0;\n  }\n  .plyr__poster {\n    width: 100% !important;\n    height: 100% !important;\n    opacity: 1;\n  }\n}\n// player paused state on initial page load to keep poster image intact, before the video has been played\n.plyr--stopped.plyr__poster-enabled {\n  iframe {\n    opacity: 0;\n  }\n  .plyr__poster {\n    width: 100% !important;\n    height: 100% !important;\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
